export default function Faq () {
  const accordionTitles = document.querySelectorAll('.mtt-faq-accordion__title')
  const activeClass = 'mtt-faq-accordion--active'

  function toggleAccordion (event) {
    const accordionElement = event.target.parentElement
    accordionElement.classList.toggle(activeClass)
  }

  if (accordionTitles.length > 0) {
    for (let i = 0; i < accordionTitles.length; i++) {
      accordionTitles[i].addEventListener('click', event => toggleAccordion(event))
    }
  }
}
